import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect} from 'react'
import api, {GetSnapshot} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number | undefined
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useSnapshot({cameraId, onError, enabled = true, ...options}: Props & Partial<UseQueryOptions<GetSnapshot>>) {
  const query = useQuery<GetSnapshot>({
    enabled,

    queryKey: [QueryKeyEnum.SNAPSHOT, cameraId],
    queryFn: async () => {
      if (!cameraId) return {time: {base64: ''}}
      const res = await api.camera.getSnapshot(cameraId)
      return res.data.data
    },
    ...options,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
